import React from 'react'
import { Row, Col } from 'reactstrap';
import PropTypes from 'prop-types'

export default function AuthHeader({
    headerText,
    description,
    icon,
}) {
    return (
        <div className="auth-header">
            <Row>
                <Col xs={7}>
                    <div className="text-primary p-4">
                        <h5 className="text-white header-text">{headerText}</h5>
                        <p>{description}</p>
                    </div>
                </Col>
                <Col className="col-5 align-self-end">
                    <img src={icon} alt="" className="img-fluid" />
                </Col>
            </Row>
        </div>
    );
}

AuthHeader.propTypes = {
    headerText: PropTypes.string,
    description: PropTypes.string,
    icon: PropTypes.any,
}